import React from 'react';
import useLanguage from '@op/hooks/useLanguage';
import { Dropdown, List } from 'tea-component';

interface ISelectDropdownProps {
  value: string;
  onChange: (value: string) => void;
  options: { key: string; labelId: string; }[];
  placement?: 'top' | 'bottom' | 'top-start' | 'top-end' | 'bottom-start' | 'bottom-end';
  style?: React.CSSProperties;
  [key: string]: any;
}

const SelectDropdown = (props: ISelectDropdownProps) => {
  const { value, onChange, options, placement = 'bottom', style = {}, ...dropdownProps } = props;
  const { formatMessage } = useLanguage();

  const menu = () => (
    <List type="option">
      {options.map(({ key, labelId }) => (
        <List.Item
          key={key}
          onClick={() => onChange(key)}
          selected={value === key}
        >
          {formatMessage({ id: labelId })}
        </List.Item>
      ))}
    </List>
  );

  const currentLabel =
    options.find(opt => opt.key === value)?.labelId || options[0]?.labelId;

  return (
    <Dropdown
      style={{ ...style }}
      button={formatMessage({ id: currentLabel })}
      appearance="link"
      placement={placement}
      {...dropdownProps}
    >
      {menu}
    </Dropdown>
  );
};

export default SelectDropdown;